import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";
import { StyledBaseEmail } from "@/styles/styled";

export const StyledEmail = styled(StyledBaseEmail)`
    margin-top: 0 !important;
`;

export const StyledConfirmationContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 1.7rem;
    text-align: center;
    @media ${breakpoints.xs} {
        p {
            font-size: var(--size-14);
        }
        img {
            width: 60px;
        }
    }
`;

export const StyledIndications = styled.div`
    align-items: center;
    font-size: var(--size-16);
    line-height: 22px;
    color: var(--color-grey-900);
    text-align: center;
    @media ${breakpoints.xs} {
        font-size: var(--size-14);
        line-height: 18px;
    }
`;
